import React from 'react';
import { Button, PageTitle } from '@cordata/buffet';
import { useHistory, useParams, Link } from 'react-router-dom';

import { Table } from '~/components/Medication';

// NOTE: Regimens are from legacy, but not reimplemented here
// since that would be having to bring in med-onc event

const MedicationsCollection = () => {
  const history = useHistory();
  const params = useParams();

  const onClick = item =>
    history.push(`/patients/${params.patient_id}/medications/${item.id}`);

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to={`/patients/${params.patient_id}/medications/add`}
            icon="plus"
          >
            Add Medication
          </Button>
        }
      >
        Medications
      </PageTitle>

      <Table
        params={{
          patient_uid: params.patient_id,
        }}
        onClick={onClick}
      />
    </>
  );
};

export default MedicationsCollection;
